<template>
	<v-card
		variant="outlined"
		class="placeholder-content sgnl-paragraph-s-regular sgnl-font-weight-light"
		@click="onClickHandler"
		:min-height="minHeight"
		v-bind="$attrs"
	>
		<template v-if="!loading">
			<slot name="icon" />
			<div class="sgnl-text-center">
				<slot name="buttonText" />
			</div>
		</template>
		<template v-else>
			<v-progress-circular
				size="24"
				class="sgnl-icon-color-tertiary"
			/>
		</template>
	</v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "SourcePlaceholderCard",
	emits: ["card-clicked"],
	props: {
		minHeight: { type: String, default: "50px" },
		loading: { type: Boolean, default: false },
	},
	methods: {
		onClickHandler() {
			this.$emit("card-clicked");
		},
	},
});
</script>

<style lang="scss" scoped>
/* Interactive extras on top of the shared .placeholder-content shell. */
.placeholder-content {
	transition: all 0.2s ease;
	background-color: var(--sgnl-default-primary-background-mono);

	&:hover {
		background-color: var(--sgnl-default-secondary-background-mono);
		cursor: pointer;
	}
}
</style>
